import {request, serviceUrl} from "@/utils/request";

// 大屏/全市环境均值（济源）
export function getOverallEnvStats() {
    return request({
        url: serviceUrl.deviceService + '/device/measuring-point-history/overall-env-stats'
    })
}

//平均温湿度
export function getTemperatureAndHumidity(spaceId) {
    return request({
        params: {
            spaceId,
        },
        url: serviceUrl.deviceService + '/device/measuring-point-history/space-temperature-and-humidity'
    })
}

//平均温湿度（含空调）
export function getTemperatureAndHumidityHistogram(spaceId) {
  return request({
      params: {
          spaceId,
      },
      url: serviceUrl.deviceService + '/device/measuring-point-history/space-temperature-and-humidity-histogram'
  })
}


//所有机房平均温湿度
export function getAllSpaceTemperatureAndHumidity() {
    return request({
        url: serviceUrl.deviceService + '/device/measuring-point-history/all-mean-temperature-and-humidity'
    })
}
//所有机房温湿度告警阈值
export function getAllSpaceTemperatureAndHumidityAlarm() {
    return request({
        url: serviceUrl.deviceService + '/device/measuring-point-history/all-mean-temperature-and-humidity-alarm'
    })
}

//根据空间,设备类型列表,测点列表获取设备测点值
export function getHistoryBySpacePoint(data) {
    return request({
        method: 'post',
        data: data,
        url: serviceUrl.deviceService + '/device/measuring-point-history/list-by-space-pointCodes-types'
    })
}

//根据空间,设备类型列表,测点列表获取设备测点值
export function getLinkDeviceBySpacePoint(data) {
    return request({
        method: 'post',
        data: data,
        url: serviceUrl.deviceService + '/device/measuring-point-history/list-camera-by-space-pointCodes-types'
    })
}

//根据设备标识,测点列表获取设备测点值
export function getHistoryByDevicePoint(data) {
    return request({
        method: 'post',
        data: data,
        url: serviceUrl.deviceService + '/device/measuring-point-history/list-by-deviceId-pointCodes'
    })
}

//获取pue总值
export function getPUE() {
    return request({
        method: 'get',
        url: serviceUrl.deviceService + '/device/measuring-point-history/getPUE'
    })
}


export function getPageByDeviceId(deviceId, current = null, size = null, value = null) {
    return request({
        url: serviceUrl.deviceService + '/device/measuring-point-history/pageBy/value',
        params: {
            deviceId,
            current,
            size,
            value
        }
    })
}

//获取历史数据
export function dataList(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/measuring-point-history/dataList',
    data: params
  })
}

// 获取历史数据文件
export function pointHistoryExportToExcel(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/measuring-point-history/export-excel',
    data: params,
    timeout: 60*20*1000
  })
}

//获取测点最新的几条数据
export function getPointValues(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/measuring-point-history/get-values',
    data: params
  })
}

//获取测点历史数据
export function getPointMonthTrend(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/measuring-point-history/getPointMonthTrend',
    data: params
  })
}

// 获取磁悬浮内机数据
export function getMagneticSuspendMachineData(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/measuring-point-history/getSpecialTypeDevicePointValues',
    data: params
  })
}

// 导出自定义报表
export function exportCustomReport(data) {
  return request({
    url:  serviceUrl.deviceService + '/device/measuring-point-history/export-report',
    method: 'post',
    data
  })
}

// 根据设备类型和测点值获取实时数据
export function getSpecialTypeValues(type, pointCodes) {
  return request({
    url: serviceUrl.deviceService + '/device/measuring-point-history/getSpecialTypeValues',
    params: { type, pointCodes }
  })
}
